angular.module('shared').factory('TemplateValidationService', ["PAYMENT_MERGE_TAGS", "CREDIT_VOUCHER_MERGE_TAGS", "MEMBERSHIP_MERGE_TAGS", "BOOKING_MERGE_TAGS", "GRADING_MERGE_TAGS", "STYLE_MERGE_TAGS", "SUSPENSION_MERGE_TAGS", "RECURRING_BOOKING_MERGE_TAGS", "LATE_CANCELLED_BOOKING_MERGE_TAGS", "BOOKING_CANCELLATION_MERGE_TAGS", "WAITLIST_ATTENDEE_MERGE_TAGS", "PERFORMED_WORKOUT_MERGE_TAGS", "$filter", function(PAYMENT_MERGE_TAGS, CREDIT_VOUCHER_MERGE_TAGS, MEMBERSHIP_MERGE_TAGS, BOOKING_MERGE_TAGS, GRADING_MERGE_TAGS, STYLE_MERGE_TAGS, SUSPENSION_MERGE_TAGS, RECURRING_BOOKING_MERGE_TAGS, LATE_CANCELLED_BOOKING_MERGE_TAGS, BOOKING_CANCELLATION_MERGE_TAGS, WAITLIST_ATTENDEE_MERGE_TAGS, PERFORMED_WORKOUT_MERGE_TAGS, $filter) {
  return {
    subjectIsNotEmpty: function(subject) {
      return !!$filter('sanitizeEditorField')(subject || '', true, {
        target: 'subject'
      });
    },
    contentIsNotEmpty: function(content) {
      return !!$filter('sanitizeEditorField')(content || '', true);
    },
    containsMergeTags: function(template, tags) {
      return _.find(tags, function(tag) {
        var ref, ref1;
        return ((ref = template.body) != null ? ref.indexOf(`{${tag}}`) : void 0) > -1 || ((ref1 = template.subject) != null ? ref1.indexOf(`{${tag}}`) : void 0) > -1;
      });
    },
    containsBookingMergeTags: function(template) {
      return this.containsMergeTags(template, BOOKING_MERGE_TAGS);
    },
    containsPaymentMergeTags: function(template) {
      if (this.containsMergeTags(template, PAYMENT_MERGE_TAGS)) {
        return true;
      }
      return this.containsMergeTags(template, CREDIT_VOUCHER_MERGE_TAGS);
    },
    containsMembershipMergeTags: function(template) {
      return this.containsMergeTags(template, MEMBERSHIP_MERGE_TAGS);
    },
    containsGradingMergeTags: function(template) {
      return this.containsMergeTags(template, GRADING_MERGE_TAGS);
    },
    containsStyleMergeTags: function(template) {
      return this.containsMergeTags(template, STYLE_MERGE_TAGS);
    },
    containsSuspensionMergeTags: function(template) {
      return this.containsMergeTags(template, SUSPENSION_MERGE_TAGS);
    },
    containsRecurringBookingMergeTags: function(template) {
      return this.containsMergeTags(template, RECURRING_BOOKING_MERGE_TAGS);
    },
    containsLateBookingCancellationMergeTags: function(template) {
      return this.containsMergeTags(template, LATE_CANCELLED_BOOKING_MERGE_TAGS);
    },
    containsBookingCancellationMergeTags: function(template) {
      return this.containsMergeTags(template, BOOKING_CANCELLATION_MERGE_TAGS);
    },
    containsWaitlistAttendeeMergeTags: function(template) {
      return this.containsMergeTags(template, WAITLIST_ATTENDEE_MERGE_TAGS);
    },
    containsPerformedWorkoutMergeTags: function(template) {
      return this.containsMergeTags(template, PERFORMED_WORKOUT_MERGE_TAGS);
    }
  };
}]);
